import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import useRole from '~/store/user/hooks/useRole';
import { NETWORK, VIEW_CLIENT_ALLOCATION } from '~/ui/constants/paths';
import { NETWORK_TAB_SLUGS } from '~/ui/pages/Network/constants';

interface IUseAllocationCancelNavigateOptions {
  actTeamId: string;
  allocationDate: string;
}

const useAllocationCancelNavigate = ({
  actTeamId,
  allocationDate,
}: IUseAllocationCancelNavigateOptions) => {
  const [withClearDraft, setWithClearDraft] = useState(false);
  const navigate = useNavigate();
  const { isActTeam, isGlobalUser } = useRole();

  const handleCancel = useCallback(() => {
    setWithClearDraft(true);

    if (isGlobalUser || isActTeam) {
      const finalRoute = VIEW_CLIENT_ALLOCATION.replace(':actTeamId', actTeamId).replace(
        ':clientAllocationDate',
        allocationDate.split('T')[0],
      );

      navigate(finalRoute);
      return;
    }

    navigate(`${NETWORK}?tab=${NETWORK_TAB_SLUGS.MANAGE_ALLOCATION}`);
  }, [actTeamId, allocationDate, isActTeam, isGlobalUser, navigate]);

  return {
    handleCancel,
    withClearDraft,
  };
};

export default useAllocationCancelNavigate;
